import React from "react";
import Toaster from "toastr";
import DisputeDetails from "./disputesModalDetailsSection";
import DisputeActions from "./disputeModalActions";
import DisputeComments from "./disputeModalComments";
import DisputeJournal from "./disputeModalJournal";
import DisputeSettlements from "./disputeModalSettlementSection";
import DisputeEvidences from "./disputeModalEvidenceSection";
import Modal from "../../../common/modal";
import Progress from "../../../common/progress";
import NetworkErrorDiv from "../../../common/networkErrorDiv";
import NewClaimModalContent from "../../newClaim/newClaimModalContent";
import DisputesApi from "../../../../api/DisputesApi";
import Constants from "../../../../configurations/constants";
import Permissions from "../../../../configurations/permissions";
import Messages from "../../../../configurations/messages";
import Util from "../../../../util/util";
import { Permissioned } from "react-permissions";
import { connect } from "react-redux";
import ValidatorHelper from "../../../common/validatorhelpers";

class DisputeModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loadingDispute: 1,
      performingAction: 0,
      actions: [],
      dispute: this.props.dispute,
      comment: "",
      evidences: [],
      disputeTransaction: null
    };

    this.commentChangeHandler = this.commentChangeHandler.bind(this);
    this.evidenceAddedHandler = this.evidenceAddedHandler.bind(this);
    this.actionCallback = this.actionCallback.bind(this);
    this.isValid = this.isValid.bind(this);
  }
  componentDidMount() {
    this.loadDispute();
  }
  commentChangeHandler(event) {
    this.setState({ comment: event.target.value });
  }

  evidenceAddedHandler(evidences) {
    this.setState({ evidences: evidences });
  }

  render() {
    return (
      <Modal
        title={`${this.state.dispute.logCode} ${
          this.state.disputeTransaction ? "- Reopen Dispute" : ""
        }`}
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onRequestClose}
      >
        {this.state.loadingDispute === 0 &&
          !this.state.disputeTransaction && (
            <div>
              <DisputeDetails dispute={this.state.dispute} />
              <DisputeSettlements logCode={this.state.dispute.logCode} />
              {this.state.actions.length > 0 && (
                <DisputeComments
                  comment={this.state.comment}
                  onCommentChangeHandler={this.commentChangeHandler}
                />
              )}
              <DisputeEvidences
                onEvidenceAddedHandler={this.evidenceAddedHandler}
                evidences={this.state.dispute.evidence}
                disableUpload={
                  this.state.actions.filter(
                    action =>
                      action[Constants.STATUS_ACTION_REQUIRED_PROPS].indexOf(
                        Constants.DISPUTE_FIELD_EVIDENCE
                      ) !== -1
                  ).length <= 0
                }
              />

              <DisputeJournal dispute={this.state.dispute} />
              <DisputeActions
                actions={this.state.actions}
                hasCancel={true}
                cancelHandler={this.props.onRequestClose}
                disabled={this.state.performingAction === 1}
              />
            </div>
          )}
        {this.state.loadingDispute === 1 && <Progress />}
        {this.state.loadingDispute === -1 && (
          <NetworkErrorDiv title="" description="" />
        )}
        {this.state.disputeTransaction && (
          <NewClaimModalContent
            transaction={this.state.disputeTransaction}
            closeModal={this.props.onRequestClose}
            isDisputeReOpen={true}
          />
        )}
      </Modal>
    );
  }

  loadDispute() {
    this.setState({ loadingDispute: 1 });
    DisputesApi.getDispute(this.state.dispute.logCode)
      .then(response => {
        let data = response.data;
        const journal = data.journal.map(journal => {
          return {
            ...journal,
            addedOn: Util.toUserLocalTime(journal.addedOn)
          };
        });
        const evidence = data.evidence.map(evidence => {
            return {
                ...evidence,
                addedOn: Util.toUserLocalTime(evidence.addedOn)
            }
        })
        data = {
          ...data,
          transactionDate: Util.toUserLocalTime(data.transactionDate),
          createdOn: Util.toUserLocalTime(data.createdOn),
          statusStartDate: Util.toUserLocalTime(data.statusStartDate),
          statusScheduledEndDate: Util.toUserLocalTime(
            data.statusScheduledEndDate
          ),
          journal,
          evidence
        };
        this.setState({ loadingDispute: 0, dispute: data });
        this.mapActions(response.data);
      })
      .catch(error => {
        this.setState({ loadingDispute: -1 });
        Util.errorMessageToast(Toaster, error.data, [
          `${error.statusText}`,
          `${Messages.ERROR_DISPUTE_FETCH_TITLE}`
        ]);
      });
  }

  loadDisputeReOpen() {
    this.setState({ performingAction: 1 });
    DisputesApi.getDisputeReOpenTransaction(this.state.dispute.logCode)
      .then(response => {
        let transaction = response.data;
        transaction.logCode = this.state.dispute.logCode;
        this.setState({ performingAction: 0, disputeTransaction: transaction });
      })
      .catch(error => {
        this.setState({ performingAction: 0 });
        Util.errorMessageToast(Toaster, error.data, [
          `${error.statusText}`,
          `${Messages.ERROR_DISPUTE_TRANSACTION_FETCH}`
        ]);
      });
  }

  mapActions(dispute) {
    let actions = dispute.statusActions ? dispute.statusActions : [];
    actions = actions.map(action => {
      action.handler = this.actionCallback;
      return action;
    });
    this.setState({ actions: actions });
  }

  actionCallback(actionObject) {
    let updateParams = {};
    updateParams.action = actionObject.action;
    switch (actionObject.action) {
      case Constants.DISPUTE_ACTION_REOPEN:
        this.loadDisputeReOpen();
        break;
      default:
        //Check that the Object validatable Objects
        if (Constants.STATUS_ACTION_REQUIRED_PROPS in actionObject) {
          if (this.isValid(actionObject, updateParams)) {
            //add comment irrespective of action
            updateParams.comment = this.state.comment;
            this.updateDisputeAction(updateParams);
          }
        }
    }
  }

  isValid(actionObject, updateParams) {
    let error_count = 0;
    const fieldCount =
      actionObject[Constants.STATUS_ACTION_REQUIRED_PROPS].length;

    for (var i = 0; i < fieldCount; i++) {
      const currentField =
        actionObject[Constants.STATUS_ACTION_REQUIRED_PROPS][i];

      switch (currentField) {
        case Constants.DISPUTE_FIELD_COMMENT:
          //Handle the Validation for comment
          if (
            ValidatorHelper.isEmpty(this.state.comment.trim()) ||
            !ValidatorHelper.StringNotEmpty(this.state.comment.trim())
          ) {
            Toaster.error(Messages.ERROR_COMMENT_REQUIRED);
            error_count++;
          } else {
            updateParams.comment = this.state.comment;
          }
          break;

        case Constants.DISPUTE_FIELD_EVIDENCE:
          //handle the Validation for Evidences
          if (this.state.evidences.length <= 0) {
            Toaster.error(Messages.ERROR_EVIDENCE_REQUIRED);

            error_count++;
          } else {
            updateParams.evidence = this.state.evidences;
          }
          break;
        default:
          break;
      }
    }
    return error_count < 1;
  }

  updateDisputeAction(params) {
    this.setState({ performingAction: 1 });
    DisputesApi.updateDispute(this.state.dispute.logCode, params)
      .then(response => {
        Toaster.success(
          `${Messages.SUCCESS_DISPUTE_ACTION} - ${params.action}`,
          this.state.dispute.logCode
        );
        //Close modal
        this.props.onRequestClose(null, true);
        this.setState({ performingAction: 0 });
      })
      .catch(error => {
        //TODO Flag invalid fields if bad request
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_DISPUTE_ACTION}`,
          this.state.dispute.logCode
        ]);
        this.setState({ performingAction: 0 });
      });
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(DisputeModal, [
    Permissions.CREATE_DISPUTE,
    Permissions.VIEW_DISPUTE,
    Permissions.UPDATE_DISPUTE
  ])
);



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputeModal.js